import { ORDER_TYPE } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/types'
import {
  PAYMENT__MENTORING_TYPE,
  type PaymentMentoringType
} from '@algoacademy/backend/modules/payment/enums'
import { z } from 'zod'
import type { MentoringOfferProduct } from './mentoring-terms'

/**
 * The checkout order and the offer describe the same product with the same
 * string, but TypeScript keeps enum members and literal unions apart, so the
 * two vocabularies are matched up explicitly.
 */
export const MENTORING_TYPE_BY_ORDER: Record<MentoringOfferProduct['order'], PaymentMentoringType> =
  {
    [ORDER_TYPE.GROUP_MENTORING]: PAYMENT__MENTORING_TYPE.GROUP_MENTORING,
    [ORDER_TYPE.INDIVIDUAL_MENTORING]: PAYMENT__MENTORING_TYPE.INDIVIDUAL_MENTORING,
    [ORDER_TYPE.PROJECT_MENTORING]: PAYMENT__MENTORING_TYPE.PROJECT_MENTORING
  }

/** The lookup only fires once the typed address could belong to somebody. */
export const studentEmailLookupZ = z.email().max(254)

/** Same normalization the API uses - one place for hook and submit. */
export function normalizeStudentEmailForLookup(email: string): string {
  return email.trim().toLowerCase()
}

export function isStudentEmailReadyForLookup(email: string): boolean {
  return studentEmailLookupZ.safeParse(normalizeStudentEmailForLookup(email)).success
}

/** The API keeps a złoty discount in grosze; every control here speaks złoty. */
export const GROSZE_PER_ZLOTY = 100
